import type { FC } from 'react';
import { Button, Grid, MenuItem, Select } from '@material-ui/core';
import DatePicker from '../../../../components/global/DatePicker';

const Filter: FC<{ onSubmit: Function, changeFilter: any, formFilter: any }> = ({ onSubmit, changeFilter, formFilter }) => (
  <>
    <Grid container spacing={2}>
      <Grid item xl={2} md={2} xs={6}>
        <DatePicker
          value={formFilter.startDate}
          label="Desde:"
          name="startDate"
          onChange={changeFilter}
        />
      </Grid>
      <Grid item xl={2} md={2} xs={6}>
        <DatePicker
          value={formFilter.endDate}
          label="Hasta:"
          name="endDate"
          onChange={changeFilter}
        />
      </Grid>
      <Grid item xl={2} md={2} xs={6}>
        <Select
          size="small"
          value={formFilter.modo}
          label="modo"
          name="modo"
          onChange={(e) => changeFilter(e.target.name, e.target.value)}
        >
          <MenuItem value="canal">Canal</MenuItem>
          <MenuItem value="convenio">Convenio</MenuItem>
          <MenuItem value="usuario">Usuario</MenuItem>
          <MenuItem value="jefeRelacion">Jefe de relación</MenuItem>
          <MenuItem value="jefeNegocio">Jefe de negocio</MenuItem>
        </Select>
      </Grid>
      <Grid item xl={2} md={2} xs={6}>
        <Button
          onClick={() => onSubmit()}
          value="Aceptar"
          title="Aceptar"
          color="primary"
          variant="contained"
          fullWidth
        >
          Consultar
        </Button>
      </Grid>
    </Grid>
  </>
);

export default Filter;
